import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
    width: "100%",
    height: "100%",
    minWidth: 0,
    minHeight: 0,
    overflow: "hidden",
  },

  stickyTop: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: designTokens.neutral.white,
  },

  sectionScrollArea: {
    flex: "1 1 0",
    minHeight: 0,
    minWidth: 0,
    overflowY: "auto",
    overflowX: "hidden",
    overscrollBehavior: "contain",
    WebkitOverflowScrolling: "touch",
    padding: designTokens.spacing[4],
    display: "flex",
    flexDirection: "column",
    backgroundColor: designTokens.neutral.white,
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: designTokens.shadow.sm,
  },

  headerRow: {
    display: "flex",
    paddingTop: designTokens.spacing[4],
    paddingRight: designTokens.spacing[4],
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  title: {
    lineHeight: 1.1,
  },

  tabList: {
    "--colorCompoundBrandForeground1": designTokens.neutral[900],
    "--colorCompoundBrandForeground1Hover": designTokens.neutral[900],
    "--colorCompoundBrandForeground1Pressed": designTokens.neutral[900],
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
    marginLeft: designTokens.spacing[6],
  },

  tab: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.normal,
    color: designTokens.neutral[500],
    "&::after": {
      width: "100%",
      left: 0,
      right: 0,
    },
  },

  configureButton: {
    paddingLeft: designTokens.spacing[2],
    paddingRight: designTokens.spacing[2],
    gap: "2px",
    "& .fui-Button__icon": {
      marginRight: "0",
    },
  },

  notFoundText: {
    textAlign: "center" as const,
  },

  tabContentArea: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
  },
});
